import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import { apiService } from '@/api';

export const useAutenticacaoStore = defineStore(
    'autenticacao',
    () => {
        const usuarioLogado = ref(false)
        const token = ref(null)
        const empresaAtual = ref(null)
        const dataExpiracao = ref(null)

        const estaAutenticado = computed(() => {
            if (!usuarioLogado.value || !token.value) return false
            
            if (!dataExpiracao.value) return true
            
            const now = new Date()
            const expirationDate = new Date(dataExpiracao.value)
            return now < expirationDate
        })

        function definirSessao(dados) {
            if (!dados || !dados.token) {
                return
            }
            token.value = dados.token
            usuarioLogado.value = true
            dataExpiracao.value = dados.expiration
            if (dados.current_logged_company) {
                empresaAtual.value = dados.current_logged_company
            }
        }

        function definirEmpresaAtual(empresa) {
            empresaAtual.value = empresa
        }

        function encerrarSessao() {
            usuarioLogado.value = false
            token.value = null
            empresaAtual.value = null
            dataExpiracao.value = null
        }

        const isTokenNearExpiration = computed(() => {
            if (!dataExpiracao.value) return false
            
            const now = new Date()
            const expirationDate = new Date(dataExpiracao.value)
            const oneHour = 60 * 60 * 1000 // 5 minutes in milliseconds
            
            return (expirationDate - now) <= oneHour
        })

        async function refreshToken() {
            try {
                const response = await apiService.requisicao('refreshToken', { token: token.value })
                if (response?.token) {
                    definirSessao(response)
                    return true
                }
                return false
            } catch (error) {
                console.error('Error refreshing token:', error)
                return false
            }
        }

        async function verificarEAtualizarToken() {
            if (isTokenNearExpiration.value) {
                return await refreshToken()
            }
            return true
        }

        return {
            usuarioLogado,
            token,
            dataExpiracao,
            empresaAtual,
            estaAutenticado,
            definirSessao,
            definirEmpresaAtual,
            encerrarSessao,
            verificarEAtualizarToken,
            isTokenNearExpiration,
        }
    },
    {
        persist: true,
    }
)
